// Dead placeholder for the future V3 customer quote landing page.
// Route: /quote/:ref — reserved now, wired to nothing. When the interactive
// accept flow ships, this page will render the web version of the quote.
import { useParams } from "react-router-dom";
import { Clock } from "lucide-react";

export default function QuoteLanding() {
  const { ref } = useParams();
  return (
    <div
      data-testid="quote-landing-placeholder"
      style={{
        minHeight: "100vh",
        background: "#0F1729",
        color: "#FBFAF8",
        display: "grid",
        placeItems: "center",
        fontFamily: "'Space Grotesk', system-ui, sans-serif",
        padding: "24px",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 460 }}>
        <div
          style={{
            width: 56, height: 56, margin: "0 auto 20px", borderRadius: 14,
            display: "grid", placeItems: "center",
            background: "rgba(232,114,44,0.15)", border: "1px solid rgba(232,114,44,0.35)",
          }}
        >
          <Clock style={{ width: 26, height: 26, color: "#E8722C" }} />
        </div>
        <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, letterSpacing: 3, color: "#C8A46B", textTransform: "uppercase" }}>
          Construction Warehouse · Quote
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 700, margin: "10px 0 8px" }}>
          {ref || "Your quote"}
        </h1>
        <p style={{ color: "#9AA4B2", fontSize: 15, lineHeight: 1.6 }}>
          The online quote view is coming soon. You'll be able to see your quote,
          download the PDF, and accept — right here.
        </p>
        <p style={{ color: "#5B6472", fontSize: 12, marginTop: 18, fontFamily: "'JetBrains Mono', monospace" }}>
          In the meantime, your account manager can send you the PDF directly.
        </p>
      </div>
    </div>
  );
}
